<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="奖项名称"
        >
          <a-input
            placeholder="请输入奖项名称"
            v-decorator="['honorName', validatorRules.honorName]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="奖项类型"
        >
          <a-select
            v-decorator="[
              'honorType_dictText',
              validatorRules.honorType_dictText
            ]"
            placeholder="请选择奖项类型"
          >
            <a-select-option
              @click="chooseHonerType(item)"
              :value="item.id"
              v-for="(item, index) in typeList"
              :key="index"
            >
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="来源">
          <a-input
            placeholder="请输入来源"
            :max-length="16"
            v-decorator="['honorFrom', validatorRules.honorFrom]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="索引">
          <a-input-number
            :min="1"
            v-decorator="['showIndex', validatorRules.showIndex]"
          ></a-input-number>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <!-- <a-input
            placeholder="请输入备注"
            :max-length="16"
            v-decorator="['remark', validatorRules.remark]"
          /> -->
          <a-textarea
            placeholder="请输入备注"
            v-decorator="['remark', validatorRules.remark]"
            :auto-size="{ minRows: 2, maxRows: 6 }"
          />
        </a-form-item>
        <a-form-item
          label="奖励年份"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-date-picker
            v-decorator="['honorYear', validatorRules.honorYear]"
            style="width: 100%"
            placeholder="请选择奖励年份"
            :format="dateFormatYear"
            :mode="year"
            :open="open"
            @openChange="openChange"
            @change="clearTime"
            @panelChange="panelChange"
          />
        </a-form-item>
        <a-form-item
          label="奖励月份"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select v-decorator="['honorMonth']" placeholder="请选择奖励月份">
            <a-select-option :value="1">1</a-select-option>
            <a-select-option :value="2">2</a-select-option>
            <a-select-option :value="3">3</a-select-option>
            <a-select-option :value="4">4</a-select-option>
            <a-select-option :value="5">5</a-select-option>
            <a-select-option :value="6">6</a-select-option>
            <a-select-option :value="7">7</a-select-option>
            <a-select-option :value="8">8</a-select-option>
            <a-select-option :value="9">9</a-select-option>
            <a-select-option :value="10">10</a-select-option>
            <a-select-option :value="11">11</a-select-option>
            <a-select-option :value="12">12</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item
          label="奖励月份"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-date-picker
            v-decorator="['honorMonth']"
            style="width: 100%"
            placeholder="请选择奖励月份"
            :mode="month"
            :open="open"
            @openChange="openChange"
            @change="clearTime"
          >
          </a-date-picker>
        </a-form-item> -->
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import { ajaxGetDictItems } from '@/api/api';

import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import moment from 'moment';
export default {
  data() {
    return {
      typeList: [], //奖励类型
      title: '新增',
      visible: false,
      year: 'year',
      month: 'month',
      open: false, //年份弹窗
      openShow: false, //月份弹窗
      dateFormatYear: 'YYYY',
      dateFormatMonth: 'MM',
      // model:'year',
      model: {},
      typeText: '',
      value: '',
      yearPick: null,
      yearPickShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        honorType_dictText: {
          rules: [{ required: true, message: '请输入奖励类型!' }]
        },
        honorName: { rules: [{ required: true, message: '请输入奖励名称!' }] },
        honorYear: { rules: [{ required: true, message: '请选择获奖年份!' }] },
        address: { rules: [{ required: true, message: '请输入地址!' }] },
        positionDes: {
          rules: [{ required: true, message: '请输入职位描述!' }]
        },
        email: { rules: [{ required: true, message: '请输入投递邮箱!' }] },
        endTime: { rules: [{ required: true, message: '请输入招聘时间!' }] }
      },
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/honer/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/honer/update'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  created() {
    this.getTypeList();
  },
  methods: {
    chooseHonerType(item) {
      // this.honorType = item.text;
      this.model.honorType = item.value;
    },
    //获取banner分类
    getTypeList() {
      let code = 'cm_ct_honer';
      ajaxGetDictItems(code, null).then(res => {
        if (res.success) {
          res.result.map(item => {
            if (item.title != '全部') {
              this.typeList.push(item);
            }
          });
        }
      });
    },
    add() {
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      if (record.honorYear) {
        record.honorYear = moment(record.honorYear).format('YYYY');
      }
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'honorFrom',
            'honorName',
            'honorType',
            'honorYear',
            'remark',
            'showIndex',
            'honorType_dictText',
            'honorMonth'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange(date, dateString) {
      this.honorYear = date.valueOf();
      console.log(this.honorYear, dateString);
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'POST';
          } else {
            httpurl += this.url.edit;
            method = 'POST';
          }
          let formData = Object.assign(this.model, values);
          formData.honorYear = moment(formData.honorYear).format('YYYY');
          // formData.honorMonth = moment(formData.honorMonth).format('MM');
          //时间格式化
          httpAction(httpurl, formData, method).then(res => {
            console.log(res);
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    //弹出日历和关闭日历的回调
    openChange(status) {
      console.log(status);
      if (status) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
    //弹出日历和关闭日历的回调
    // openChanges(status) {
    //   console.log(status);
    //   if (status) {
    //     this.openShow = true;
    //   } else {
    //     this.openShow = false;
    //   }
    // },
    //日期面板变化时的回调
    panelChange(value) {
      this.form.setFieldsValue({
        honorYear: value
      });
      console.log(value);
      this.open = false;
    },
    //月份获取值
    // panelChanges(value) {
    //   this.form.setFieldsValue({
    //     honorMonth: value
    //   });
    //   console.log(value);
    //   this.openShow = false;
    // },
    clearTime() {
      this.form.setFieldsValue({
        honorYear: null,
        honorMonth: null
      });
    }
  }
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
